import { render, staticRenderFns } from "./CookiesPage.vue?vue&type=template&id=4a5d7a0c&scoped=true&"
import script from "./CookiesPage.js?vue&type=script&lang=js&"
export * from "./CookiesPage.js?vue&type=script&lang=js&"
import style0 from "./CookiesPage.scss?vue&type=style&index=0&id=4a5d7a0c&lang=scss&scoped=true&"
import style1 from "./CookiesPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5d7a0c",
  null
  
)

export default component.exports